import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let username = localStorage.getItem('nombre_usuario');
        let password = localStorage.getItem('password_usuario');

        let authorizationData = 'Basic ' + btoa(username + ':' + password);

        if (req.headers.get("skip")){
            const headers = req.clone({
                headers: req.headers.delete('skip')
            });

            
            return next.handle(headers);
        }
        

        const headers = req.clone({
            headers: req.headers.set('content-type', 'application/json').set('Access-Control-Allow-Origin', '*').set('authorization', authorizationData)
        });





        return next.handle(headers);
    }
}